/**
 * 我采购的询比价列表地址
 */
export const INQUIRY_AUCTION_PURCHASE_LIST_PAGE_PATH =
  '/auction/inquiry/list/purchase'
